module.exports = __webpack_public_path__ + "static/media/merin.4f27fd14.webp";